import React from 'react'
import { messageTypes } from '../../../../actions/messages'
import ResourceFilesFormComponent from '../../../common/filesForm'
import {
  Form, Select, Input, InputNumber, Button, Divider, Tooltip
} from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import settings from '../../../../config/'

const { Option } = Select
const { TextArea } = Input

class StyledMachinesForm extends ResourceFilesFormComponent {
  formRef = React.createRef()

  prepareFormValues (values) {
    return {
      desc: { pl: values.desc_pl, en: values.desc_en },
      machine_name: values.machine_name,
      order: values.order,
      console: values.console,
      stack_types: values.stack_types,
      active: values.active === 'yes'
    }
  }

  prepareFormExistingValues (data) {
    return {
      desc_pl: data.desc ? data.desc.pl : '',
      desc_en: data.desc ? data.desc.en : '',
      machine_name: data.machine_name,
      order: data.order ? data.order : 0,
      console: data.console || 'default',
      stack_types: data.stack_types,
      active: ((data.active || data.active === undefined) && 'yes') || 'no'
    }
  }

  prepareFormDefaultValues () {
    return {
      desc_pl: '',
      desc_en: '',
      machine_name: '',
      order: 0,
      console: 'default',
      stack_types: undefined,
      active: 'yes'
    }
  }

  handleStackTypeChange = (selectedStackTypes) => {
    this.setState({ selectedStackTypes })

    this.props.getMachinesForStackTypes(this.state.machineName || this.props.data?.machine_name, selectedStackTypes)
  }

  handleMachineNameChange = (machineName) => {
    this.setState({ machineName })

    this.props.getMachinesForStackTypes(machineName, this.state.selectedStackTypes || this.props.data?.stack_types)
  }

  render () {
    const { language, loading, machines, singleDataVmware, data } = this.props

    return (
      <Form onFinish={this.handleSubmit} layout='horizontal' ref={this.formRef}>

        <Form.Item
          name='stack_types'
          label={messageTypes[language].stack_types}
          rules={[{ required: true, message: messageTypes[language].field_required }]}
          {...this.formItemLayout}
        >
          <Select onChange={this.handleStackTypeChange} mode='multiple'>
            {
              settings.stack_types.length
                ? settings.stack_types.map((stackType, n) =>
                  <Option key={n} value={stackType}>{stackType}</Option>
                )
                : ''
            }
          </Select>
        </Form.Item>

        <Form.Item
          name='machine_name'
          label={messageTypes[language].machine_name}
          rules={[{ required: true, message: messageTypes[language].field_required }]}
          {...this.formItemLayout}
        >
          <Select placeholder={messageTypes[language].machines} disabled={machines === undefined} onChange={this.handleMachineNameChange}>
            {
              machines?.map((vm, i) => (
                <Option key={i} value={vm.name.toLowerCase()}>{vm.name}</Option>
              ))
            }
          </Select>
        </Form.Item>

        <Form.Item
          name='desc_pl'
          label={messageTypes[language].desc_pl}
          rules={[{ required: true, message: messageTypes[language].field_required }]}
          {...this.formItemLayout}
        >
          <TextArea rows={6} />
        </Form.Item>

        <Form.Item
          name='desc_en'
          label={messageTypes[language].desc_en}
          rules={[{ required: true, message: messageTypes[language].field_required }]}
          {...this.formItemLayout}
        >
          <TextArea rows={6} />
        </Form.Item>

        <Form.Item
          name='console'
          label={messageTypes[language].console}
          {...this.formItemLayout}
        >
          {((singleDataVmware === undefined) &&
            <Tooltip placement='top' title={messageTypes[language].machine_not_available_in_stack}>
              <Select disabled defaultValue={data?.console}>
                <Option key='default' value='default'>włączona</Option>
                <Option key='disabled' value='disabled'>wyłączona</Option>
              </Select>
            </Tooltip>) || (
              <Select disabled={singleDataVmware?.console === false}>
                <Option key='default' value='default'>{((singleDataVmware?.console === false && 'wyłączona - ') || (singleDataVmware?.console === true && 'włączona - '))}domyślne ustawienie stacka</Option>
                <Option key='disabled' value='disabled'>wyłączona</Option>
              </Select>)}
        </Form.Item>

        <Form.Item
          name='active'
          label={messageTypes[language].active3}
          {...this.formItemLayout}
        >
          {(singleDataVmware === undefined &&
            <Tooltip placement='top' title={messageTypes[language].machine_not_available_in_stack}>
              <Select disabled defaultValue={data?.active}>
                <Option key='yes' value='yes'>tak</Option>
                <Option key='no' value='no'>nie</Option>
              </Select>
            </Tooltip>) || (
              <Select>
                <Option key='yes' value='yes'>tak</Option>
                <Option key='no' value='no'>nie</Option>
              </Select>)}
        </Form.Item>

        <Form.Item
          name='order'
          label={messageTypes[language].order}
          {...this.formItemLayout}
        >
          <InputNumber min={0} />
        </Form.Item>

        {this.fileFieldsRender('machines')}

        <Form.Item className='form-footer'>
          <Divider />
          <Button htmlType='submit'>{loading ? <LoadingOutlined /> : ''} {messageTypes[language].submit}</Button>
          <Button onClick={() => { this.props.onCancel() }} className='cancel'>{messageTypes[language].cancel}</Button>
        </Form.Item>
      </Form>
    )
  }
}

export default StyledMachinesForm
